import { toast } from "./toast";
import { errorMessageOf } from "../api/scholarships";
import { showDocument } from "./documentViewer";

// Shows a file the API sends as an attachment in the app's document viewer; `load` resolves to its Blob
export const openFile = async (load, fileName = "") => {
  try {
    await showDocument(load, fileName);
  } catch (error) {
    console.error("Failed to open a file:", error);
    toast.error(errorMessageOf(error, "Could not open the document. Please try again."));
  }
};
